import { render, staticRenderFns } from "./MedicalItem.vue?vue&type=template&id=3e454ff9&scoped=true&"
import script from "./MedicalItem.vue?vue&type=script&lang=js&"
export * from "./MedicalItem.vue?vue&type=script&lang=js&"
import style0 from "./MedicalItem.vue?vue&type=style&index=0&id=3e454ff9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e454ff9",
  null
  
)

export default component.exports